/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Download Type
 */
export type BeneficiaryDeedRequestDownloadType = typeof BeneficiaryDeedRequestDownloadType[keyof typeof BeneficiaryDeedRequestDownloadType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BeneficiaryDeedRequestDownloadType = {
  BeneficiaryDeed: 'BeneficiaryDeed',
  LetterOfWishes: 'LetterOfWishes',
} as const;
